import React from "react";
import { Phone, MessageCircle } from "lucide-react";

const FloatingButtons = () => {
  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col gap-2 sm:gap-3" data-testid="floating-buttons">
      <a
        href="https://wa.me/41796070148"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-[#25D366] text-white shadow-lg hover:shadow-2xl hover:scale-105 transition-all"
        data-testid="float-whatsapp"
      >
        <MessageCircle size={22} className="sm:hidden" fill="white" strokeWidth={1.5} />
        <MessageCircle size={26} className="hidden sm:block" fill="white" strokeWidth={1.5} />
      </a>
      <a
        href="tel:+41796070148"
        aria-label="Anrufen"
        className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-red-600 text-white shadow-lg hover:shadow-2xl hover:scale-105 hover:bg-red-700 transition-all"
        data-testid="float-call"
      >
        <Phone size={20} className="sm:hidden" />
        <Phone size={24} className="hidden sm:block" />
      </a>
    </div>
  );
};

export default FloatingButtons;
